import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0.06 0.034 15 15" {...props}><path d="M1.26 12.033l-1.2 3.001 3-1.201 9.6-9.6-1.801-1.799zM11.46 1.834l1.8-1.8 1.799 1.8-1.8 1.8z" /></svg>);